import * as yup from 'yup';

export const CreateJobValidationSchema = yup
	.object({
		start_date: yup.date().nullable(),
		end_date: yup.date().nullable(),
	})
	.test(
		'both-dates-or-none',
		'Both start date and end date are required ',
		function (values) {
			const { start_date, end_date } = values as {
				start_date: Date | null;
				end_date: Date | null;
			};

			if ((start_date && !end_date) || (!start_date && end_date)) {
				return this.createError({
					path: start_date ? 'end_date' : 'start_date',
					message: 'Both start date and end date are required ',
				});
			}
			return true;
		},
	)
	.test(
		'start-before-end',
		'Start date must be before or equal to end date',
		function (values) {
			const { start_date, end_date } = values as {
				start_date: Date | null;
				end_date: Date | null;
			};

			if (start_date && end_date && start_date > end_date) {
				return this.createError({
					path: 'start_date',
					message: 'Start date must be before or equal to end date',
				});
			}

			return true;
		},
	);
